module.exports = __webpack_public_path__ + "content/918b537061219ca9f50b0b9e2bdab536.png";